"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloadExcel = exports.TableToExcelReact = void 0;
const react_1 = __importDefault(require("react"));
const useExportExcel_1 = require("./hooks/useExportExcel");
Object.defineProperty(exports, "useDownloadExcel", { enumerable: true, get: function () { return useExportExcel_1.useDownloadExcel; } });
const TableToExcelReact = ({ table, fileName, sheet, id, className, children, }) => {
    const { onDownload } = (0, useExportExcel_1.useDownloadExcel)({
        table,
        fileName,
        sheet,
        id,
        className,
    });
    return react_1.default.createElement("span", { onClick: onDownload }, children);
};
exports.TableToExcelReact = TableToExcelReact;
